<template>
	<fieldset id="submit" class="pt-3 pb-3">
		<div class="container pt-5 pb-4">
			<div class="row">
				<div class="col-4">
					<button class="btn btn-gradient btn-submit">
						<span>
							<slot>
								Size Your System
							</slot>
						</span>
					</button>
				</div>

				<div class="col-8">
					<div class="disclaimer">
						<p class="text-tiny">
							Ecotope, Southern California Edison (“SCE”), Sacramento Municipal Utility District (“SMUD”), Bonneville Power Administration ("BPA"), Northwest Energy Efficiency Alliance ("NEEA"), and Oakridge National Laboratory ("ORNL") provide this software program (“Ecosizer”) for the intended “educational and informational” purposes only, and none of these funders guarantees that the information provided by the software is correct, complete, or current. While the computational results of the software may be used only for your design considerations, they should not be used for determining compliance with any applicable federal, state, or local laws or regulations. Please consult a professional to ensure accuracy for your particular requirements.
						</p>

						<p class="text-tiny">
							It is a condition of us allowing you free access to this Ecosizer software program that you agree to the following:
						</p>

						<ul class="text-tiny">
							<li>
								None of these funders, nor any of their employees, directors, owners, contractors or subcontractors, will be liable for any action you take in reliance on the information provided by the software. Additionally, you understand and agree that none of these funders makes any warranty, express or implied; or assumes any legal liability or responsibility for the accuracy, completeness or usefulness of any data, information, method, or results disclosed in this Ecosizer software program; or represents that its use will not infringe any privately-owned rights including, but not limited to patents, trademarks or copyrights.
							</li>

							<li>
								Ecotope, SCE, SMUD, BPA, NEEA, and ORNL are providing this information in good faith for the intended “educational and informational” purposes only.
							</li>
						</ul>

						<p class="text-tiny">
							By using the Ecosizer software program and downloading results, you agree to the above conditions, and if you provide comments and suggestions for improvements to the software program they may be used for any purpose without restriction, obligation or remuneration of any kind.
						</p>
					</div>
				</div>
			</div>
		</div>
	</fieldset>
</template>
